import React from 'react';
import { iconsPath } from '../../utils/imagePath';
import useClickOutside from '../UseClickOutside';

const SupportMenu = ({
  handlePopupToggle,
  isPopupOpen,
  setIsPopupOpen,
  animationHeight,
  isAnimationMinimized,
}) => {
  const Help = [
    {
      icon: iconsPath?.Help1Image,
      label: 'Send Feadback',
      action: () => handlePopupToggle('Feedback'),
    },
    { icon: iconsPath?.Help2Image, label: 'Help Center' },
    {
      icon: iconsPath?.Help3Image,
      label: 'Learning Center',
      action: () => handlePopupToggle('Learning'),
    },
    {
      icon: iconsPath?.Help4Image,
      label: 'Keyboard Shortcuts',
      action: () => handlePopupToggle('Shortcuts'),
    },
    // { icon: iconsPath?.Help4Image, label: 'Journey' },
  ];

  const modelRef = React.useRef(null);
  useClickOutside(modelRef, () => {
    setIsPopupOpen(null);
  });
  return (
    <div className="fixed top-0 left-0 w-full h-full  z-50 flex items-center justify-center">
      <div
        ref={modelRef}
        className={`absolute   right-[248px] bg-[#131418] rounded-[5px] w-[160px] h-fit z-[9999] px-3 py-1 transition-all duration-300 ease-in-out transform ${
          isPopupOpen === 'Help'
            ? 'opacity-100 translate-x-0'
            : 'opacity-0 translate-x-4 pointer-events-none transition-transform scale-105'
        } ${animationHeight && !isAnimationMinimized ? 'bottom-[252px]' : 'bottom-[60px]'}`}
      >
        <ul>
          {Help.map((item, index) => (
            <li
              key={index}
              className="flex items-center py-1 whitespace-nowrap cursor-pointer z-[999999]"
              onClick={item.action ? item.action : null}
            >
              <img className="w-4 h-4 mr-2" src={item.icon} alt="" />
              <span className="text-white text-[12px] font-normal">
                {item.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SupportMenu;
